import {
  Box,
  Space
} from '@looker/components'

import React, { useContext, useEffect } from 'react'

import _ from 'lodash'
import { useParams } from 'react-router'
import { Accordion, AccordionSummary, AccordionDetails, FormControl, FormLabel, FormGroup, Checkbox, FormControlLabel } from '@material-ui/core'
import { KeyboardArrowDown, Circle } from '@styled-icons/material-outlined'
import { CheckCircleFill } from '@styled-icons/bootstrap'

export const Filter: React.FC<any> = ({
    options,
    optionLabel,
    name,
    setCurrentFilter,
    currentFilter
}) => {

  const [checked, setChecked] = React.useState({});

  const handleCheckboxChange = (event) => {
    console.log(event.target.name + event.target.checked)
    setChecked({ ...checked,
      [event.target.name]: event.target.checked
    });
  }

  const updateFilterValues = (value) => {
    console.log(name)
    setCurrentFilter({
      ...currentFilter,
      [name] : value
    });
  }

  useEffect(() => {
    let currentChecked = Object.keys(checked).filter(k => {
      return checked[k] === true
    });
    console.log(currentChecked)
    updateFilterValues(currentChecked)
  }, [checked])

  return (
    <>
      <Box className='filter-content'>
        <Accordion defaultExpanded>
          <AccordionSummary style={{color:"#a20067", fontWeight:"600"}} expandIcon={<KeyboardArrowDown width={"20px"} style={{color:"#a20067"}} />}>
            {optionLabel}
          </AccordionSummary>
          <AccordionDetails style={{maxHeight:"250px", overflowY:"auto"}}>
            <FormControl component="fieldset" variant="standard">
              <FormGroup>
                {
                  options?.map(o => 
                    <FormControlLabel  className='filter-row'
                      key={o}
                      control={
                        <Checkbox onChange={(e) => handleCheckboxChange(e)}  name={o} icon={<Circle width={"20px"} />} checkedIcon={<CheckCircleFill width={"20px"} style={{color:"#a20067"}}/>}/>
                      }
                      label={o}                
                    />
                  )
                }

              </FormGroup>
            </FormControl>
          </AccordionDetails>
        </Accordion>
      </Box>    
    </>
  )
}
